import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';
import useSWR from 'swr';
import type { GetForecastGraphRequest, GetForecastGraphResponse } from '~/api/aspida/@types';
import { getForecastGraph } from '~/api/forecastGraph';

// child_id 未確定時は fetch をスキップする
type UseGetForecastGraphArgs = Omit<GetForecastGraphRequest, 'child_id'> & {
  child_id: GetForecastGraphRequest['child_id'] | undefined;
};

export const useGetForecastGraph = (
  args: UseGetForecastGraphArgs,
): SWRResponse<GetForecastGraphResponse, AxiosError> => {
  const canFetch = args.child_id !== undefined;
  return useSWR(canFetch ? ['getForecastGraph', args] : null, ([_, args]) =>
    getForecastGraph({
      child_id: args.child_id as GetForecastGraphRequest['child_id'],
      regionCode: args.regionCode,
    }),
  );
};
